<template>
  <a
    href="javascript:void(0)"
    class="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
    v-b-tooltip.hover.bottom
    :title="computedTitle"
    @click="resendUserInvite"
  >
    <span class="svg-icon svg-icon-md svg-icon-primary">
      <inline-svg src="media/svg/icons/Communication/Mail.svg" />
    </span>
  </a>
</template>

<script>
import { RESEND_USER_INVITE } from "@/core/services/store/core/user.module.js";

export default {
  name: "ResendInvite",

  props: {
    user: { type: Object, required: true },
    projectId: { type: Number, required: false },
    clientId: { type: Number, required: false }
  },

  methods: {
    resendUserInvite: function() {

      let payload = {
        email: this.user.calculatedEmail,
        projectId: this.projectId,
        clientId: this.clientId
      };

      this.$store.dispatch(RESEND_USER_INVITE, payload)
      .then(() => {
        this.$emit('users_changed');
        this.$swal.fire({
          title: `${this.$t("SWEETALERTS.RESEND_SUCCESS.TITLE")}`,
          text: this.user.display_name + ' ' + `${this.$t("SWEETALERTS.RESEND_SUCCESS.MESSAGE")}`,
          icon: 'success',
          confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
        })
      })
      .catch(err => {
        let errors = err.response.data.errors;
        this.alertFailure(errors);
      });
    },
    alertFailure: function(errors) {
      let type = "generic_failure";
      let translation = "RESEND_FAIL";

      if (errors.user_id != undefined) {
        if (errors.user_id.includes("Project does not contain the required settings to send to My Own Audience")) {
          type = "moa_failure";
          translation = "RESEND_FAIL_MOA";
        }
      }

      this.$swal.fire({
        title: `${this.$t(`SWEETALERTS.${translation}.TITLE`)}`,
        text: `${this.$t(`SWEETALERTS.${translation}.MESSAGE`)}`,
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: (type == "generic_failure") ? `${this.$t("GENERAL.TEXT.CONFIRM")}` : `${this.$t("GENERAL.TEXT.FIX")}`
      }).then((result) => {
        if (result.isConfirmed && type == "moa_failure") {
          this.$router.push({ name: "setup_theme", params: { tab: 3 } })
        }
      })
    }
  },

  computed: {
    computedTitle: function() {
      if (this.user.invite_sent == 1) {
        return `${this.$t("TABLES.USER_TOOLTIPS.RESEND")}`
      } else {
        return `${this.$t("TABLES.USER_TOOLTIPS.SEND")}`
      };
    }
  }
};
</script>
